'use strict';

module.exports = () => {

    const sidebar = document.querySelector('.sticky-sidebar');

    if (!sidebar) return;


    const handleScroll = () => {

        const isMobile = window.innerWidth < 768;


        const startPosition = isMobile ? 350 : 600;
        const fixedTop = isMobile ? 85 : 400;


        const scroll = window.scrollY;


        if (scroll + fixedTop >= startPosition) {

            sidebar.classList.add('is-fixed');

        } else {

            sidebar.classList.remove('is-fixed');

        }

    };


    window.addEventListener('scroll', handleScroll);

    window.addEventListener('resize', handleScroll);

    handleScroll();


    const items = document.querySelectorAll('.sticky-sidebar__item');


    items.forEach(item => {

        item.addEventListener('click', function (e) {

            if (window.innerWidth <= 768) {

                e.stopPropagation();

                // если уже открыт - закрываем
                if (this.classList.contains('active')) {

                    this.classList.remove('active');

                } else {

                    // закрываем остальные
                    items.forEach(el => {
                        el.classList.remove('active');
                    });

                    // открываем текущий
                    this.classList.add('active');

                }

            }

        });

    });


    document.addEventListener('click', function () {

        if (window.innerWidth <= 768) {

            items.forEach(item => {
                item.classList.remove('active');
            });

        }

    });


    sidebar.addEventListener('click', function(e){
        e.stopPropagation();
    });


};